import { addListener, lanuch } from 'devtools-detector';
import videojs from 'video.js';
import { environment } from '../../services/environment';

class CourseVideo
{
  constructor ( $state, authService, $scope, courseVideoService )
  {
    'ngInject';

    Object.assign( this, { $state, authService, $scope, courseVideoService } );
    this.consoleIsClosed = true
    this.unitVideoId = 'unit-video'
  }

  $onInit ()
  {
    if ( this.modifier )
    {
      this.unitVideoId += this.modifier
    }
    this.lectureUrl = this.videoLink || this.courseVideoService.getFileURL( this.modifier )
    this.drawVideoPlayer()

    if ( !environment.debug )
    {
      addListener( ( isOpened ) =>
      {
        this.consoleIsClosed = !isOpened
        if ( this.consoleIsClosed )
        {
          this.drawVideoPlayer()
        }
        this.$scope.$apply()
      } );
      lanuch()
    }
  }

  drawVideoPlayer ()
  {
    this.lectureUrl = this.videoLink || this.courseVideoService.getFileURL( this.modifier )
    const enablePlayer = setInterval( () =>
    {
      const videoPlayer = document.querySelector( `#${ this.unitVideoId } #video-js` )
      if ( videoPlayer && this.consoleIsClosed )
      {
        clearInterval( enablePlayer )
        this.createVideoPlayer( videoPlayer )
        setTimeout( () =>
        {
          const videoHeight = $( `#${ this.unitVideoId } video` ).height()
          $( `#${ this.unitVideoId } #video-js` ).css( { height: videoHeight + 'px' } )
        }, 1000 )
      }
    } )
  }

  createVideoPlayer ( videoPlayer )
  {
    const options = {
      controls: true,
      controlBar: {
        fullscreenToggle: false,
        pictureInPictureToggle: false
      }
    }
    const player = videojs( videoPlayer, options );
    videoPlayer.addEventListener( 'contextmenu', ( e ) =>
    {
      e.preventDefault()
    } )
    // disable full screen mode
    player.on( "fullscreenchange", () =>
    {
      if ( player.isFullscreen() )
      {
        player.exitFullscreen();
      }
    } );
    //
    this.watermarkText = `© video for ${ this.authService.userData.firstName } ${ this.authService.userData.lastName }`;
  }

  $onDestroy ()
  {
    if ( !environment.debug )
      stop();
  }

}

export default CourseVideo;



// WEBPACK FOOTER //
// ./client/app/blocks/courseVideo/courseVideo.controller.js